import {
  ACTIVATE_LOAN_SUCCESS,
  ADD_BULK_LOAN_SUCCESS,
  ADD_CM_TO_LOAN_SUCCESS,
  ADD_LOAN_FAILURE,
  ADD_LOAN_SUCCESS,
  DEACTIVATE_LOAN_SUCCESS,
  DOWNLOAD_LOAN_BULK_TEMPLATE_SUCCESS,
  EMPTY_ALL_LOANS,
  EMPTY_ALL_LOAN_BENEFICIARIES_TO_LOAN,
  EMPTY_ALL_TOTAL_LOAN_BENEFICIARY,
  EMPTY_LOAN_BY_ID,
  EMPTY_LOAN_SELECT,
  EMPTY_TOTAL_LOANS,
  EXPORT_LOANS_SUCCESS,
  EXPORT_LOAN_BENEFICIARIES_BY_LOAN_SUCCESS,
  FETCH_ALL_LOANS_SUCCESS,
  FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN,
  FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN_SUCCESS,
  FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS_SUCCESS,
  FETCH_ALL_TOTAL_LOAN_DETAILS_SUCCESS,
  FETCH_LOAN_BY_ID_SUCCESS,
  FETCH_LOAN_SELECT_SUCCESS,
  RESTORE_LOAN_BENEFICIARIES_TO_LOAN_INITIAL,
  RESTORE_LOAN_INITIAL,
  UPDATE_LOAN_SUCCESS,
} from "../ActionTypes";

const INIT_STATE = {
  loanCreated: false,
  loanBeneficiaryCreated: false,
  loansFetched: [],
  awardedCMFetched: [],
  totalLoanCount: {},
  // totalLBCount: {},
  loanActivated: false,
  loanDeactivated: false,
  loan: {},
  totalLoanDetails: {},
  totalLoanBeneficiaryDetails: {},
  loanSelectFetched: [],
  loanUpdated: false,
  loansCSV: false,
  lbByloanCSV: false,
  loansPDF: false,
  isLoading: true,
  isLoaded: true,
  isFetched: false,
  isFetching: false,
  bulkLoansCSV:false,
  bulkUploadData:false,
};

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case ADD_LOAN_SUCCESS: {
      return {
        ...state,
        loanCreated: true,
      };
    }
    case ADD_LOAN_FAILURE: {
      return {
        ...state,
        loanCreated: false,
      };
    }
    case FETCH_ALL_LOANS_SUCCESS: {
      return {
        ...state,
        loansFetched: action.payload.data,
        totalLoanCount: action.payload.meta.totalCount,
      };
    }
    case EMPTY_ALL_LOANS: {
      return {
        ...state,
        loansFetched: [],
      };
    }
    case RESTORE_LOAN_INITIAL: {
      return {
        ...state,
        loanCreated: false,
        loanActivated: false,
        loanDeactivated: false,
        loanUpdated: false,
        isLoading: true,
      };
    }
    case ACTIVATE_LOAN_SUCCESS: {
      return {
        ...state,
        loanActivated: true,
      };
    }
    case DEACTIVATE_LOAN_SUCCESS: {
      return {
        ...state,
        loanDeactivated: true,
      };
    }
    case FETCH_LOAN_BY_ID_SUCCESS: {
      return {
        ...state,
        loan: action.payload,
      };
    }
    case EMPTY_LOAN_BY_ID: {
      return {
        ...state,
        loan: {},
      };
    }
    case FETCH_ALL_TOTAL_LOAN_DETAILS_SUCCESS: {
      return {
        ...state,
        totalLoanDetails: action.payload,
        isLoaded: false,
      };
    }
    case EMPTY_TOTAL_LOANS: {
      return {
        ...state,
        totalLoanDetails: {},
      };
    }
    case UPDATE_LOAN_SUCCESS: {
      return {
        ...state,
        loanUpdated: true,
      };
    }
    case EXPORT_LOANS_SUCCESS: {
      return {
        ...state,
        loansCSV: action.payload,
      };
    }
    case FETCH_ALL_TOTAL_LOAN_BENEFICIARY_DETAILS_SUCCESS: {
      return {
        ...state,
        totalLoanBeneficiaryDetails: action.payload,
        isLoaded: false,
      };
    }
    case EMPTY_ALL_TOTAL_LOAN_BENEFICIARY: {
      return {
        ...state,
        totalLoanBeneficiaryDetails: {},
      };
    }
    case FETCH_LOAN_SELECT_SUCCESS: {
      return {
        ...state,
        loanSelectFetched: action.payload,
        isFetched: true,
      };
    }
    case EMPTY_LOAN_SELECT: {
      return {
        ...state,
        loanSelectFetched: [],
      };
    }
    case ADD_CM_TO_LOAN_SUCCESS: {
      return {
        ...state,
        loanBeneficiaryCreated: true,
      };
    }
    case FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case FETCH_ALL_LOAN_BENEFICIARIES_TO_LOAN_SUCCESS: {
      return {
        ...state,
        awardedCMFetched: action.payload.data,
        // totalLBCount: action.payload.meta.totalCount,
        isFetching: false,
      };
    }
    case EMPTY_ALL_LOAN_BENEFICIARIES_TO_LOAN: {
      return {
        ...state,
        awardedCMFetched: [],
      };
    }
    case RESTORE_LOAN_BENEFICIARIES_TO_LOAN_INITIAL: {
      return {
        ...state,
        loanBeneficiaryCreated: false,
        isLoading: true,
      };
    }
    case EXPORT_LOAN_BENEFICIARIES_BY_LOAN_SUCCESS: {
      return {
        ...state,
        lbByloanCSV: action.payload,
      };
    }
    case DOWNLOAD_LOAN_BULK_TEMPLATE_SUCCESS: {
      return{
        ...state,
       bulkLoansCSV: action.payload,
      };
    }
    case ADD_BULK_LOAN_SUCCESS: {
      return{
        ...state,
        bulkUploadData: true,
      };
    }
    default:
      return state;
  }
}

export default reducers;
